import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { tailscaleWeb } from '../web-manifest.js';
import { TailscaleIcon } from './icons/TailscaleIcon.js';

export default createWebRegistrationFromManifest(
  tailscaleWeb,
  {
    TailscalePage: () => import('./TailscalePage'),
    TailscaleProfilePicker: () => import('./TailscaleProfilePicker'),
    TailscaleProfileSummary: () => import('./TailscaleProfileSummary'),
    TailscaleMentionProvider: () => import('./TailscaleMentionProvider'),
    TailscaleMentionCreate: () =>
      import('./TailscaleMentionCreate').then((m) => ({ default: m.TailscaleMentionCreate })),
    TailscaleDetailSection: () => import('./TailscaleDetailSection'),
    TailscalePreview: () =>
      import('./TailscalePreview').then((m) => ({ default: m.TailscalePreview })),
    TailscaleProfileCardPreview: () =>
      import('./TailscaleProfileCardPreview').then((m) => ({
        default: m.TailscaleProfileCardPreview,
      })),
  },
  {
    icons: { Tailscale: TailscaleIcon },
  },
);
